const NpsFilterOptions = [
  {
    name: 'Status',
    label: 'Open comments',
    value: [1, null]
  },
  {
    name: 'Status',
    label: 'Processed comments',
    value: 2
  },
  {
    name: 'Status',
    label: 'Ignored comments',
    value: 3
  }
]

export default NpsFilterOptions
